/**
 * @fileoverview Provides Git utility functions: `add`, `commit`, `getRepoRoot`, and `isInGitRepo`. These functions execute Git commands within a specified directory using Node.js's `child_process`. The functions operate on strings representing file paths and commit messages.
 */

import { exec, execSync } from 'child_process'
import { promisify } from 'util'

const execAsync = promisify(exec)

export async function add(directory: string) {
  await execAsync('git add .', { cwd: directory })
}

export async function commit(message: string, directory: string) {
  await execAsync(`git commit -m "${message.replace(/"/g, '\\"')}"`, { cwd: directory })
}

export function getRepoRoot(cwd: string): string | undefined {
  try {
    const stdout = execSync('git rev-parse --show-toplevel', {
      cwd,
      stdio: ['pipe', 'pipe', 'ignore'], // Ignore stderr
    }).toString()
    return stdout.trim()
  } catch (error) {
    return undefined
  }
}

export function isInGitRepo(cwd: string): boolean {
  return getRepoRoot(cwd) !== undefined
}
